export interface ITimeframe {
  type: string;
  startDate: Date | string | undefined;
  endDate: Date | string | undefined;
}

export class Timeframe {
  public type: string;
  public startDate: Date | string | undefined;
  public endDate: Date | string | undefined;

  constructor(data: ITimeframe) {
    this.type = data.type;
    this.startDate = data.startDate;
    this.endDate = data.endDate;
  }
}
